import "./singleUser.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import DatatableForOpen from "../../components/datatableForStatusOpen/DatatableForOpen";
import {ticketOpenColumns} from "../../components/datatableTicketSolve/dataticketopen";

const SingleUser = () => {
  const [info, setInfo] = useState([]);
  const { data, loading, error } = useFetch(`/users/_current`);

  useEffect(() => {
    setInfo(data);
  }, [data]);

  console.log(info)
  const dateTicket = () => {
    const dateCreated = new Date(data.created_at);
    const dateUpdate = new Date(data.updated_at);
    const date = {
      create_at : dateCreated.toLocaleString(),
      updated_at: dateUpdate.toLocaleString()
    }
    return date;
  }
  const date = dateTicket()


  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar/>
        <div className="top">
          {loading ? (
              "loading"
          ) : (
              <div className="left">

                <Link to="/users/_current/update">
                  <div className="editButton">Edit</div>
                </Link>
                <h1 className="title">Information Profile User</h1>
                <div className="item">
                  <img
                      src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                      alt=""
                      className="itemImg"
                  />
                  <div className="details">
                    <h1 className="itemTitle">{info.id}</h1>
                    <div className="detailItem">
                      <span className="itemKey">Email : </span>
                      <span className="itemValue">{info.email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Name : </span>
                      <span className="itemValue">{info.company_name}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">userName : </span>
                      <span className="itemValue">{info.username}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Region : </span>
                      <span className="itemValue">{info.region_id}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Role : </span>
                      <span className="itemValue" style={{ fontWeight: 600, color: info.role_id === 1 ? "#2e7d32" : "#1976d2" }}>
                        {info.role_id === 1 ? "Admin" : info.role_id === 2 ? "Customer" : info.role_id === 99 ? "Superadmin" : (info.role_id ? `Role ${info.role_id}` : "-")}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Created At : </span>
                      <span className="itemValue">{date.create_at}</span>
                    </div>
                  </div>
                </div>
              </div>)}

        </div>
        <div className="bottom">
          <div>
            <h1 className="title">Last Open Ticket</h1>
            <DatatableForOpen columns={ticketOpenColumns}/>
        </div>
      </div>
    </div>
</div>
)
  ;
};

export default SingleUser;
